export default "__VITE_ASSET__9756733f__"